import styled from "styled-components";
import { IoIosArrowForward, IoIosArrowBack } from 'react-icons/io'
import { add } from "date-fns";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// components
import Navbar from "../../components/allies/Navbar";
import Tours from "../../components/allies/Tours";
import Menu from "../../components/allies/Menu";
import CurrentDay from "../../components/allies/CurrentDay";
// context
import { useAlly } from "../../context/ally";
// modals
import TripInfo from "../../components/allies/modals/TripInfo";
import Summary from "../../components/allies/modals/Summary";
import EditReservation from "../../components/allies/modals/EditReservation";
import CreateGroup from "../../components/allies/modals/CreateGroup";
import AddReservationGroup from "../../components/allies/modals/AddReservationGroup";
import TicketPaymentGroup from "../../components/allies/modals/TicketPaymentGroup";
import ConfirmBoucher from "../../components/allies/modals/ConfirmBoucher";
import ConfirmDeleteReservation from "../../components/allies/modals/ConfirmDeleteReservation";
import Passengers from "../../components/allies/modals/Passengers";

export default function HomeAlly() {
    const {
        user,
        currentDay, 
        setCurrentDay, 
        tripInfo, 
        isCreateGroupModalOpen,
        newGroup,
        isTicketPaymentGroupModalOpen,
        isConfirmBoucherModalOpen,
        isSummaryModalOpen,
        editReservationId,
        confirmDeleteReservationId,
        isPassengersModalOpen,
    } = useAlly()
    const router = useNavigate()
    function handleCurrentDay (action: 'forwards' | 'backwards') {
        const newDate = add(currentDay, {days: action === 'backwards' ? -1 : 1} )
        setCurrentDay(newDate)
    }
    useEffect(() => {
        if (!user) return router('/ally/access')
    }, [user, router])
    return (
        <Main>
            <Navbar/>
            <Background>
            </Background>
            <Modal>
                <button className="back"
                onClick={() => handleCurrentDay('backwards')}
                >
                    <IoIosArrowBack/>
                </button>
                <button className="forw"
                onClick={() => handleCurrentDay('forwards')}
                >
                    <IoIosArrowForward/>
                </button>
                <CurrentDay/>
                <Menu/>
                <Tours/>
            </Modal>
            {
                tripInfo &&
                <TripInfo/>
            }
            {
                isCreateGroupModalOpen &&
                <CreateGroup/>
            }
            {
                newGroup.length > 0 &&
                <AddReservationGroup/>
            }
            {
                isTicketPaymentGroupModalOpen &&
                <TicketPaymentGroup/>
            }
            {
                isConfirmBoucherModalOpen &&
                <ConfirmBoucher/>
            }
            {
                isSummaryModalOpen &&
                <Summary/>
            }
            {
                editReservationId &&
                <EditReservation/>
            }
            {
                confirmDeleteReservationId &&
                <ConfirmDeleteReservation/>
            }
            {
                isPassengersModalOpen &&
                <Passengers/>
            }
        </Main>
    )
}

const Main = styled.div`
height: 100dvh;
width: 100vw;
position: relative;
`

const Background = styled.div`
position: absolute;
height: 100%;
width: 100%;
background: linear-gradient(-45deg, #0B2043 0%, #1A365D 100%);
`

const Modal = styled.div`
height: 70%;
width: 85%;
background-color: ${props => props.theme.white};
border-radius: 10px;
max-width: 900px;
position: absolute;
top: 60%;
left: 50%;
transform: translate(-50%, -50%);
box-shadow: 0 10px 10px ${props => props.theme.blackTransparent};
> button {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 30px;
    border: none;
    background-color: ${props => props.theme.white};
    font-size: 16px;
    position: absolute;
    top: -40px;
    color: #000;
    box-shadow: 0 5px 3px ${props => props.theme.blackTransparent};
    transition: transform .3s ease;
    cursor: pointer;
    &:hover {
        transform: translateY(-3px);
    }
    &.back {
        left: 0;
    }
    &.forw {
        right: 0;
    }
}
`